const CREATIVE_ID_SUFFIX = /~(?:VOD|STREAM)$/;

export const getPublicCreativeId = (creativeId) => {
    if (creativeId == null) return creativeId;
    return String(creativeId).trim().replace(CREATIVE_ID_SUFFIX, "");
};
